import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { AiFillInstagram } from "react-icons/ai";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaPinterestP,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoCall, IoMail } from "react-icons/io5";
import { Link } from "react-router-dom";
import amex from "../../assets/img/payements-icons/amex.svg";
import bhim from "../../assets/img/payements-icons/bhim.svg";
import gpay from "../../assets/img/payements-icons/gpay.svg";
import mastercard from "../../assets/img/payements-icons/mastercard.svg";
import paytm from "../../assets/img/payements-icons/paytm.svg";
import phonepe from "../../assets/img/payements-icons/phonepe.svg";
import rupay from "../../assets/img/payements-icons/rupay.svg";
import upi from "../../assets/img/payements-icons/upi.svg";
import visa from "../../assets/img/payements-icons/visa.svg";
import { store } from "../../Helper/Context/Store";
import GetApiCall from "../../Helper/GetApi";
import SocialIcons from "../WrappperComponent/SocialIcons";
import logo from "../../assets/img/floral-logo.webp"
import "./Footer.css";
export default function Footer() {
  const { clientData, siteHeader } = useContext(store);
  const [staticPages, setStaticPages] = useState([]);

  useEffect(() => {
    GetApiCall.getRequest("GetStaticPagesList").then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setStaticPages(obj1.data);
        }
      })
    );
  }, []);
  return (
    <>
      {/* <footer className="section-spacing-x section-spacing-x-mobile">
        <div className="container-fluid pt-4 pb-3 border-bottom border-white">
          <div className="row">
            <div className="col-lg-6">
              <span className="fs-5 mb-0 d-flex flex-column flex-lg-row text-md-center text-lg-start social-icon-bullet align-items-lg-center">
                <a href={`tel:${clientData[0]?.mobile}`}>
                  <IoCall /> {clientData[0]?.mobile}{" "}
                  <span className="d-none d-lg-inline ms-1">|</span>
                </a>
                <a
                  href={`mailto:${clientData[0]?.email}`}
                  className="ms-lg-2 mt-1 mt-lg-0">
                  <IoMail /> {clientData[0]?.email}{" "}
                  <span className="d-none d-lg-inline ms-1">|</span>
                </a>

                <ul className="footer-sm-icons justify-content-md-center mt-3 mb-md-4 mb-lg-0 mt-lg-0 ms-lg-2">
                  <SocialIcons
                    link={clientData[0]?.facebook}
                    target="_blank"
                    logo={<FaFacebookF />}
                  />
                  <SocialIcons
                    link={clientData[0]?.instagram}
                    target="_blank"
                    logo={<AiFillInstagram />}
                  />
                  <SocialIcons
                    link={clientData[0]?.twitter}
                    target="_blank"
                    logo={<FaXTwitter />}
                  />
                  <SocialIcons
                    link={clientData[0]?.linkedin}
                    target="_blank"
                    logo={<FaLinkedinIn />}
                  />
                  <SocialIcons
                    link={clientData[0]?.pintrest}
                    target="_blank"
                    logo={<FaPinterestP />}
                  />
                  <SocialIcons
                    link={clientData[0]?.youtube}
                    target="_blank"
                    logo={<FaYoutube />}
                  />
                </ul>
              </span>
            </div>
            <div className="col-lg-6 d-flex align-items-lg-center justify-content-md-center justify-content-lg-end">
              <ul className="payments-icons ps-0">
                <li>
                  <img alt="" src={mastercard} />
                </li>
                <li>
                  <img alt="" src={visa} />
                </li>
                <li>
                  <img alt="" src={amex} />
                </li>
                <li>
                  <img alt="" src={bhim} />
                </li>
                <li>
                  <img alt="" src={gpay} />
                </li>

                <li>
                  <img alt="" src={paytm} />
                </li>
                <li>
                  <img alt="" src={phonepe} />
                </li>
                <li>
                  <img alt="" src={rupay} />
                </li>
                <li>
                  <img alt="" src={upi} />
                </li>
              </ul>
            </div>
            <div className="col-12 mt-3">
              <ul className="d-flex flex-wrap flex-lg-nowrap flex-column flex-md-row main-nav-menu-links px-0 justify-content-center align-items-lg-center">
                {staticPages.map((link, index) => (
                  <li key={index}>
                    <Link to={link.fld_route}>{link.fld_page_name}</Link>
                  </li>
                ))}

                <li>
                  <Link to={"/contact-us"}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <div className="container-fluid px-lg-4 footer-bottom py-2">
        <div className="row flex-column-reverse flex-lg-row">
          <div className="col-12 col-lg-6 text-lg-start text-center">
            Powered by{" "}
            <a href="https://bechofy.in/" target="blank">
              {" "}
              Bechofy
            </a>{" "}
            - <br className="d-block d-md-none" /> A Product of
            <a href="https://globaltrendz.com/" target="blank">
              &nbsp; Global Trendz
            </a>
          </div>
          <div className="col-12 col-lg-6 text-lg-end text-center">
            <p className="mb-0">
              Copyright &copy; {moment().format("YYYY")} {clientData[0]?.name}.
              <br className="d-block d-md-none" /> All Rights Reserved.
            </p>
          </div>
        </div>
      </div> */}
      <footer className="section-spacing-x section-spacing-x-mobile">
        <div className="container-fluid pt-4 pb-3 border-white">
          <div className="row">
            <div className="col-lg-3 col-12 mb-lg-0 mb-4">
              <Link to="/">
                <img alt="" src={logo} className="img-fluid nav-logo-footer mb-3" />
              </Link>
              <p className="mb-1 mb-lg-2">Floral Hut is a trusted florist in Chennai, offering fresh flower bouquets and same day delivery for all special occasions.</p>

              <span className="fs-5 mb-0 d-flex flex-column flex-lg-row text-md-center text-lg-start social-icon-bullet align-items-lg-center d-lg-none d-block">
                <a href={`tel:${clientData[0]?.mobile}`}>
                  <IoCall /> {clientData[0]?.mobile}{" "}
                  <span className="d-none d-lg-inline ms-1">|</span>
                </a>
                <a
                  href={`mailto:${clientData[0]?.email}`}
                  className="ms-lg-2 mt-1 mt-lg-0">
                  <IoMail /> {clientData[0]?.email}{" "}
                  {/* <span className="d-none d-lg-inline ms-1">|</span> */}
                </a>


              </span>
              <ul className="footer-sm-icons justify-content-md-start mt-3 mb-md-4 mb-lg-0 mt-lg-0">
                <SocialIcons
                  link={clientData[0]?.facebook}
                  target="_blank"
                  logo={<FaFacebookF />}
                />
                <SocialIcons
                  link={clientData[0]?.instagram}
                  target="_blank"
                  logo={<AiFillInstagram />}
                />
                <SocialIcons
                  link={clientData[0]?.twitter}
                  target="_blank"
                  logo={<FaXTwitter />}
                />
                <SocialIcons
                  link={clientData[0]?.linkedin}
                  target="_blank"
                  logo={<FaLinkedinIn />}
                />
                <SocialIcons
                  link={clientData[0]?.pintrest}
                  target="_blank"
                  logo={<FaPinterestP />}
                />
                <SocialIcons
                  link={clientData[0]?.youtube}
                  target="_blank"
                  logo={<FaYoutube />}
                />
              </ul>

            </div>
            <div className="col-lg-9 ps-lg-5">
              <div className="row">
                <div className="col-lg-3 col-6 mb-lg-0 mb-3">
                  <ul className="p-0">
                    <h3 className="text-white">Our Links</h3>
                    <li>
                      <Link to={"/contact-us"}>Contact Us</Link>
                    </li>
                    {staticPages.map((link, index) => (
                      <li key={index}>
                        <Link to={link.fld_route}>{link.fld_page_name}</Link>
                      </li>
                    ))}


                  </ul>
                </div>
                <div className="col-lg-3 col-6 ps-lg-4">
                  <ul className="p-0">
                    <h3 className="text-white">Our Product</h3>
                    <li><Link to="/category/birthday">Birthday</Link></li>
                    <li><Link to="/category/wedding">Weddings </Link></li>
                    <li><Link to="/category/anniversary">Anniversary</Link></li>
                    <li><Link to="/category/flowers">Flowers</Link></li>
                    <li><Link to="/category/flower-arrangement">Flower Arrangement</Link></li>
                    <li><Link to="/category/cakes">Cakes</Link></li>
                    <li><Link to="/category/chocolate">Chocolate</Link></li>
                    <li><Link to="/category/combos">Combos</Link></li>
                  </ul>

                </div>


                <div className="col-lg-3 col-6">
                  <ul className="p-0">
                    <h3 className="text-white">Our Services</h3>

                    <li><Link to="/">Online Flower Delivery </Link>
                    </li>
                    <li><Link to="/category/birthday/flowers">Birthday Flower Delivery</Link></li>
                    <li><Link to="/category/cakes/midnight-delivery">Midnight Flowers Delivery</Link></li>
                    <li><Link to="/category/cakes">Online Cake Delivery </Link></li>
                    <li><Link to="/category/combos">Flowers and Cake Delivery</Link></li>
                    <li><Link to="/category/cakes/same-day-delivery">Same Day Flower Delivery
                    </Link></li>

                  </ul>

                </div>
                <div className="col-lg-3 col-6">
                  <ul className="p-0">
                    <h3 className="text-white"> Occasions </h3>
                    <div className="mobile-dropdown-container">
                      {siteHeader?.filter((category) => category?.id === 8)?.map((category, index) => {
                        const subcategory = category?.subcategories?.filter((subCat) => subCat?.id === 19)[0]?.subcat;
                        return (
                          <>
                            {subcategory?.map((subcat) => (
                              <li><Link to={subcat?.path}>{subcat?.label1} </Link>
                              </li>
                            ))}
                          </>
                        )
                      })}

                    </div>


                  </ul>

                </div>

              </div>

            </div>



          </div>
        </div>

      </footer>
      <footer className="section-spacing-x section-spacing-x-mobile  spacing-background">
        <div className="container-fluid pt-4 pb-3 border-bottom border-white">
          <div className="row">
            <div className="col-lg-6">
              <span className="fs-5 mb-0 d-flex flex-column flex-lg-row text-md-center text-lg-start social-icon-bullet align-items-lg-center d-lg-block d-none">
                <a href={`tel:${clientData[0]?.mobile}`}>
                  <IoCall /> {clientData[0]?.mobile}{" "}
                  <span className="d-none d-lg-inline ms-1">|</span>
                </a>
                <a
                  href={`mailto:${clientData[0]?.email}`}
                  className="ms-lg-2 mt-1 mt-lg-0">
                  <IoMail /> {clientData[0]?.email}{" "}
                  {/* <span className="d-none d-lg-inline ms-1">|</span> */}
                </a>


              </span>
            </div>
            <div className="col-lg-6 d-flex align-items-lg-center justify-content-md-center justify-content-lg-end">
              <ul className="payments-icons ps-0">
                <li>
                  <img alt="mastercard" src={mastercard} />
                </li>
                <li>
                  <img alt="visa" src={visa} />
                </li>
                <li>
                  <img alt="amex" src={amex} />
                </li>
                <li>
                  <img alt="bhim" src={bhim} />
                </li>
                <li>
                  <img alt="gpay" src={gpay} />
                </li>

                <li>
                  <img alt="paytm" src={paytm} />
                </li>
                <li>
                  <img alt="phonepe" src={phonepe} />
                </li>
                <li>
                  <img alt="rupay" src={rupay} />
                </li>
                <li>
                  <img alt="upi" src={upi} />
                </li>
              </ul>
            </div>
            {/* <div className="col-12 mt-3">
              <ul className="d-flex flex-wrap flex-lg-nowrap flex-column flex-md-row main-nav-menu-links px-0 justify-content-center align-items-lg-center">
                {staticPages.map((link, index) => (
                  <li key={index}>
                    <Link to={link.fld_route}>{link.fld_page_name}</Link>
                  </li>
                ))}

                <li>
                  <Link to={"/contact-us"}>Contact Us</Link>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </footer>
      <div className="container-fluid px-lg-4 footer-bottom py-2">
        <div className="row flex-column-reverse flex-lg-row">
          <div className="col-12 col-lg-6 text-lg-start text-center">
            Powered by{" "}
            <a href="https://bechofy.in/" target="blank">
              {" "}
              Bechofy
            </a>{" "}
            - <br className="d-block d-md-none" /> A Product of
            <a href="https://globaltrendz.com/" target="blank">
              &nbsp; Global Trendz
            </a>
          </div>
          <div className="col-12 col-lg-6 text-lg-end text-center">
            <p className="mb-0">
              Copyright &copy; {moment().format("YYYY")} {clientData[0]?.name}.
              <br className="d-block d-md-none" /> All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
      <div class="floating_btn d-flex "><a href="https://wa.me/+919003202020" class="whatsapp-btn mb-3"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg></a></div>
    </>
  );
}
